const ApplicationStatus = {
  Pending: 'PENDING',
  Accepted: 'ACCEPTED',
  Declined: 'DECLINED',
  Expired: 'EXPIRED',
  PositionClosed: 'POSITION_CLOSED',
  CandidatePlaced: 'CANDIDATE_PLACED',
}

Object.freeze(ApplicationStatus)

export { ApplicationStatus }
